module.exports = __webpack_public_path__ + "static/media/Verified.429e1b94.svg";